// TODO - Documentar
import { BandComparisonSummary } from '../components/bandComparisonSummary/BandComparisonSummary'
import BandComparisonParameters from '../components/parameters/BandComparisonParameters '
import TransactionExtractionLoadingIcons from '../components/transactions/TransactionExtractionLoadingIcons'
import { PROPORTIONAL_HEIGHT, PROPORTIONAL_WIDTH, TITLE } from '../templates/charts/ChartConstants'
import * as con from "../GlobalConstants"
import { RefUserLineApplicationParameterHook } from '../components/hooks/UserLineApplicationParametersHooks'
import { useSelector } from 'react-redux'
import { selectAllTransactionsOk } from '../store/selectors/transactionsSelectors'


function BandComparisonPage() {

    const loadingLineApplicationParameters = RefUserLineApplicationParameterHook(con.USER_LINE_APPLICATION_PARAMETERS_FETCHED)
    const transactionsLoaded = useSelector(selectAllTransactionsOk);

    return (
        <div>
            <BandComparisonParameters />
            <div style={{ paddingLeft : '5%', paddingRight : '5%'}}>
                {
                (loadingLineApplicationParameters === con.NOT_STARTED || loadingLineApplicationParameters === con.LOADING ||
                    !transactionsLoaded) ?
                    <div style={{marginTop : "25px"}}>
                        <TransactionExtractionLoadingIcons />                        
                    </div>
                    : <BandComparisonSummary chartParameters={{[TITLE] : "Valor en Riesgo x Banda de Coberturas",
                                                            [PROPORTIONAL_WIDTH] : 1200,
                                                            [PROPORTIONAL_HEIGHT] : 405}}/>
                }
            </div>
        </div>
    )
}

export default BandComparisonPage
